export default "__VITE_ASSET__RLIdG_vH__"